const BASE_SELECTOR: string = '[data-name="serverType"]';
const MAPCYCLE_INOFFICIAL_SELECTOR: string = '[data-mapcycle]';
const MAPCYCLE_OFFICIAL_SELECTOR: string = '[data-search-value="Experience"]';

export class ServerTypeUI {
  public constructor(private $base: JQuery) {
    if (this.getValue() === 'official') {
      this.toggleMapCycleOfficial(true);
      this.toggleMapCycleInofficial(false);
    } else {
      this.toggleMapCycleOfficial(false);
      this.toggleMapCycleInofficial(true);
    }
  }

  // listen to onChange
  public onChange(callback: (val: string) => void ) {
    this.$base.on('change', (e) => {
      callback(this.getValue());
    });
  }

  public getValue() : string{
    return this.$base.val() as string;
  }

  public toggleMapCycleOfficial(state: boolean) {
    if (state) {
      $(MAPCYCLE_OFFICIAL_SELECTOR).parents('.panel--settings').show();
      $(MAPCYCLE_OFFICIAL_SELECTOR).parents('.panel--settings').prev().show();
    } else {
      $(MAPCYCLE_OFFICIAL_SELECTOR).parents('.panel--settings').hide();
      $(MAPCYCLE_OFFICIAL_SELECTOR).parents('.panel--settings').prev().hide();
    }
  }

  public toggleMapCycleInofficial(state: boolean) {
    if (state) {
      $(MAPCYCLE_INOFFICIAL_SELECTOR).show();
      $(MAPCYCLE_INOFFICIAL_SELECTOR).prev().show();
    } else {
      $(MAPCYCLE_INOFFICIAL_SELECTOR).hide();
      $(MAPCYCLE_INOFFICIAL_SELECTOR).prev().hide();
    }
  }
}

export function createServerTypeInstances() : ServerTypeUI[] {
  const instances: ServerTypeUI[] = [];
  $(BASE_SELECTOR).each((index, element) => {
    instances.push(new ServerTypeUI($(element)));
  });

  return instances;
}
